import { ElementStatus } from '../types';
export const getNextRuleElementIndex = (failedElements, currentFailedElementIndex) => {
  if (currentFailedElementIndex === null) {
    return null;
  }
  const nextElement = failedElements.slice(currentFailedElementIndex + 1).findIndex(failedElement => {
    return failedElement.status === ElementStatus.Failed;
  });
  return nextElement === -1 ? null : nextElement + currentFailedElementIndex + 1;
};
//# sourceMappingURL=rule-element-navigation-utils.js.map